export default "__VITE_ASSET__BanlLmm8__"